var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    fill: "#01220D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.295 9.605L11.727 15.605C11.539 15.852 11.248 15.998 10.938 16H10.931C10.624 16 10.334 15.858 10.144 15.616L7.712 12.509C7.372 12.075 7.448 11.446 7.883 11.106C8.317 10.765 8.947 10.841 9.287 11.277L10.92 13.363L14.704 8.394C15.038 7.955 15.665 7.869 16.106 8.204C16.545 8.539 16.63 9.166 16.295 9.605ZM2 12C2 17.522 6.477 22 12 22C17.523 22 22 17.522 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12Z",
    fill: "#AFE680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledSuccessTick);
export default __webpack_public_path__ + "static/media/icon-filled-success-tick.a71114ab3bb26e5105594a036f2deb06.svg";
export { ForwardRef as ReactComponent };